const width = window.innerWidth;
const height = window.innerHeight;

export const layout = {
  window: {
    width,
    height,
  },
};
